import { render } from "./UpdatePasswordForm.vue?vue&type=template&id=013ab834"
import script from "./UpdatePasswordForm.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__